export default __webpack_public_path__ + "media/guidelines/do-e8bb1155.png";